import { render, staticRenderFns } from "./ShopCarImagesField.vue?vue&type=template&id=6f19abdb&scoped=true"
import script from "./ShopCarImagesField.vue?vue&type=script&lang=ts"
export * from "./ShopCarImagesField.vue?vue&type=script&lang=ts"
import style0 from "./ShopCarImagesField.vue?vue&type=style&index=0&id=6f19abdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19abdb",
  null
  
)

export default component.exports